import ComparisonTable from 'Components/ContractGenerator/layouts/ComparisonTable';
import Section from 'Components/ContractGenerator/layouts/Section';
import React from 'react';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';

import Footer from './Footer';
import Header from './Header';
import Products from './Products';
import SettingsArea from './SettingsArea';

const Step1 = () => {
	const hideHeader = JSON.parse(document.getElementById('viato-contract-generator').dataset?.hideMainHeadline || false);

	return (
		<Section isFirstPage>
			{!hideHeader && <Header />}

			<SettingsArea />
			<Spacer height='m' />
			<Spacer height='xl' />

			<Products />
			<Spacer height='m' />
			<Spacer height='xxl' />

			<Footer />
			<Spacer height='xl' />
			<ComparisonTable />
			<Spacer height='xxl' />
			<Spacer height='xxl' />
		</Section>
	);
};

export default Step1;
